import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { DetectEnvironment } from '../../../EnvironmentSettings';

const ChooseRegistration = (props) => {
    return (
        <div className="row" >
            <div className="col-lg-9">
                <img className="welcome-page-logo" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="logo" />
                <div className='choose-register-wrapper'>
                    <button onClick={() => props.currentScreen(1)} className='register-btn'>Register With Email<i className="fa-solid fa-envelope"></i></button>
                    <GoogleOAuthProvider clientId="GOOGLE_CLIENT_ID">
                        <span className='google-login'>
                            <GoogleLogin
                                size='large'
                                width='300px'
                                logo_alignment='left'
                                onSuccess={credentialResponse => {
                                    console.log('credentialResponse', credentialResponse);
                                }}
                                onError={() => {
                                    console.log('Login Failed');
                                }}
                            />
                        </span>
                    </GoogleOAuthProvider>

                </div>
            </div>
            <div className="right-bar welcome-right-bar col-lg-3" >
                <div>
                </div>
            </div>
        </div>
    )
}
export default ChooseRegistration;